import axios from "axios";
import { appEnv } from "../appEnv";
import {
  setLanguageInterceptor,
  setTokenRequestInterceptor,
} from "./interceptors";

const apiOcpi = axios.create({
  baseURL: `${appEnv.REACT_APP_API_URL}/proxy-ocpi`,
  withCredentials: true,
  transitional: {
    clarifyTimeoutError: true,
  },
  params: {
    tupi_cache_purge: Date.now(),
  },
});

apiOcpi.interceptors.request.use(setTokenRequestInterceptor);
apiOcpi.interceptors.request.use(setLanguageInterceptor);

export default apiOcpi;
